import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetChalanListByShop = createAsyncThunk(
  "chalan/GetChalanListByShop",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/chalan/list/${id}`);
    return data
  }
);

export const AddChalan = createAsyncThunk(
  "chalan/AddChalan",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/chalan/create/`, data)
    return response.data
  }
); 

export const UpdateChalan = createAsyncThunk(
  "chalan/UpdateChalan",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/chalan/update/${data.id}/`, data)
    // alert(response.data.message)
    return response.data
  }
);

export const DeleteChalan = createAsyncThunk(
  "chalan/DeleteChalan",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/chalan/delete/${id}/`)
    // return response.status
    return response.data
  }
);

export const GetChalanItems = createAsyncThunk(
  "chalan/GetChalanItems",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/chalan/item/list/${id}/`)
    return data
  }
);

export const GetChalanDetail = createAsyncThunk(
  "chalan/GetChalanDetail",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/chalan/detail/${id}/`)
    return data
  }
);
